module.exports = __webpack_public_path__ + "img/64ne.15cf72c7.svg";